import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

import { DocBlocks } from "@/components/docs/DocBlocks";
import { DocsShell } from "@/components/docs/DocsShell";
import { JsonLd } from "@/components/docs/JsonLd";
import { allDocPages, docHref, getDocPage, getDocSections } from "@/content/docs/index";
import { docPageJsonLd, docsHubJsonLd } from "@/lib/docsJsonLd";

export function DocsHub() {
  const page = getDocPage("index");
  const sections = getDocSections();
  const total = allDocPages().length;

  return (
    <DocsShell>
      <JsonLd data={[...docsHubJsonLd(total), ...(page ? docPageJsonLd(page) : [])]} />

      <header>
        <p className="text-xs font-semibold tracking-wide text-muted-foreground">Documentation</p>
        <h1 className="mt-3 text-balance font-sans text-4xl font-semibold tracking-tight text-foreground sm:text-[2.75rem] sm:leading-[1.1]">
          {page?.title ?? "Documentation"}
        </h1>
      </header>

      {page ? (
        <article className="mt-8">
          <DocBlocks blocks={page.blocks} />
        </article>
      ) : null}

      <div className="mt-16 space-y-12">
        {sections.map((section) => {
          const pages = section.pages
            .filter((slug) => slug !== "index")
            .map((slug) => getDocPage(slug))
            .filter((entry) => entry !== undefined);
          if (pages.length === 0) return null;

          return (
            <section key={section.id} aria-labelledby={`section-${section.id}`}>
              <h2
                id={`section-${section.id}`}
                className="font-sans text-xl font-semibold tracking-tight text-foreground"
              >
                {section.label}
              </h2>
              <p className="mt-1 text-muted-foreground">{section.blurb}</p>
              <ul className="mt-5 grid gap-3 sm:grid-cols-2">
                {pages.map((entry) => (
                  <li key={entry.slug}>
                    <Link
                      to={docHref(entry.slug)}
                      className="group block h-full rounded-card border border-border bg-card/40 px-4 py-4 transition-colors hover:border-primary/40"
                    >
                      <span className="flex items-start justify-between gap-3">
                        <span className="text-sm font-medium text-foreground">{entry.title}</span>
                        <ArrowRight
                          className="mt-0.5 h-4 w-4 shrink-0 text-subtle-foreground transition-colors group-hover:text-primary"
                          aria-hidden
                        />
                      </span>
                      <span className="mt-1.5 block text-xs leading-snug text-muted-foreground">
                        {entry.description}
                      </span>
                    </Link>
                  </li>
                ))}
              </ul>
            </section>
          );
        })}
      </div>
    </DocsShell>
  );
}
